import { render, staticRenderFns } from "./OrderReport.vue?vue&type=template&id=7284ef5d&scoped=true"
import script from "./OrderReport.vue?vue&type=script&lang=js"
export * from "./OrderReport.vue?vue&type=script&lang=js"
import style0 from "./OrderReport.vue?vue&type=style&index=0&id=7284ef5d&prod&lang=postcss"
import style1 from "./OrderReport.vue?vue&type=style&index=1&id=7284ef5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7284ef5d",
  null
  
)

export default component.exports